var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"tooltip",on:{"mouseover":function($event){_vm.hover = true},"mouseleave":function($event){_vm.hover = false},"click":function($event){_vm.hover = false}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }